export function removeFromList<T>(items: T[], index: number): T[] {
  const itemsBefore = items.slice(0, index);
  const [_, ...itemsAfter] = items.slice(index);

  return [...itemsBefore, ...itemsAfter];
}
